import { Typography } from "@mui/material";
import React from "react";
import { AuditLog } from "../../../api/auditApi";
import {
  getAssignmentActionPhrase,
  getAssignmentAssetInfo,
} from "../utils/auditDetailsUtils";
import AssignmentEntityLabel from "./AssignmentEntityLabel";

interface AssignmentActionDescriptionProps {
  auditLog: AuditLog;
  open?: boolean;
}

const AssignmentActionDescription: React.FC<AssignmentActionDescriptionProps> = ({
  auditLog,
  open = true,
}) => {
  const asset = getAssignmentAssetInfo(auditLog);

  if (!asset) {
    return null;
  }

  return (
    <Typography sx={{ fontSize: "0.9rem", fontWeight: 600, lineHeight: 1.4 }}>
      {getAssignmentActionPhrase(auditLog.action, asset.assetLabel)}{" "}
      <AssignmentEntityLabel
        component="span"
        entityType={asset.entityType}
        entityId={asset.entityId}
        open={open}
        sx={{ fontSize: "inherit", fontWeight: 700 }}
      />
    </Typography>
  );
};

export default AssignmentActionDescription;
